import { z } from "zod";
// Uniform error envelope returned by every API route on failure.
// All routes MUST return this shape on non-2xx responses. The frontend's
// fetch wrapper depends on it.
export const ApiErrorBody = z.object({
    error: z.object({
        code: z.string(), // machine-readable: e.g. "VALIDATION_FAILED", "QLIK_AUTH_FAILED"
        message: z.string(), // human-readable
        details: z.record(z.unknown()).optional(),
    }),
});
//# sourceMappingURL=api-error.js.map